<template>
  <div>
    <div
      v-translate:dynamic_string="{ key: `${translationKeyInitial}_formattedBody`, val: lang, html: question.formattedBody }"
      class="instruction_title text-left para-mrgn-20"
      v-html="question.formattedBody" />
    <div v-if="componentData.allowMultiple" v-translate:label_select_all_that_apply="lang" class="mt-10 mb-20">SELECT
      ALL THAT APPLY
    </div>
    <div v-if="getImage">
      <img :src="getImage" class="multiple-choice-img-size" width="100%" />
    </div>
    <div>
      <b-form-group v-if="componentData.subType === 'Single'" class="mb-5" @click.once="$emit('onClick', question)">
        <b-form-radio-group v-model="updatedAnswersIds[0]" :disabled="isFieldDisabled" stacked
                            v-on:change="onAnswerChange([$event])">
          <b-form-radio v-for="option in filteredOptions" :key="option.id" :value="option.id"
                        class="light custom_radio">
            <div class="ap-thread-alert-message-preview p-0 col-md-12">
              <span
                v-translate:dynamic_string="{
                  key: widget.getDynamicStringKey(translationKeyInitial, option),
                  val: lang,
                  optionId: option.id,
                  html: option.displayText ? option.displayText : option.body ? option.body : option.label
                }"
                v-html="option.displayText ? option.displayText : option.body ? option.body : option.label"
              ></span>
              <AlertMessage v-if="componentData.colorCodeEnabled && componentData.optionsIds[0] === option.id"
                            :backgroundColor="option.colorCoding && option.colorCoding.color"
                            :message="option.colorCoding && option.colorCoding.warningMessage" />
            </div>
          </b-form-radio>

          <div v-if="otherOptionModel.isEnabled" class="light custom_radio other-option-wrap">
            <b-form-radio :key="otherOptionModel.id" :value="otherOptionModel.id" class="light custom_radio">
              {{ otherOptionModel.label }}
            </b-form-radio>

            <div v-if="otherOptionModel.hasComment && isOtherSelected"
                 :class="{ 'disabled-area': !isOtherSelected, 'active-area': isOtherSelected }"
                 class="other-option-comment">
                    <textarea v-model="otherOptionModel.value"
                              :disabled="!isOtherSelected"
                              :maxlength="otherOptionModel.commentMaxLength"
                              :placeholder="otherOptionModel.comment"
                              class="other-option-comment-area"
                              @keydown="preventInvalidCharacters"
                              @change="onOtherCommentChange">
                    </textarea>

              <div :class="{'max-character-limit': otherCommentLength >= otherOptionModel.commentMaxLength}"
                   class="other-option-comment-count">
                {{ otherCommentLength }} / {{ otherOptionModel.commentMaxLength }}
              </div>
            </div>
          </div>
        </b-form-radio-group>
      </b-form-group>

      <b-form-group v-if="componentData.subType === 'Multi'" class="mb-5">
        <b-form-checkbox-group v-model="updatedAnswersIds" :disabled="isFieldDisabled" stacked
                               v-on:change="onAnswerChange($event)">
          <b-form-checkbox v-for="option in filteredOptions" :key="option.id" :value="option.id" class="light">
            <div class="ap-thread-alert-message-preview p-0 col-md-12">
              <span
                v-translate:dynamic_string="{
                  key: widget.getDynamicStringKey(translationKeyInitial, option),
                  val: lang,
                  optionId: option.id,
                  html: option.displayText ? option.displayText : option.body ? option.body : option.label
                }"
                v-html="option.displayText ? option.displayText : option.body ? option.body : option.label"
              ></span>
              <div
                v-for="(id, index) in componentData.optionsIds"
                :key="index"
                :style="{
                  marginBottom: componentData.colorCodeEnabled && option.colorCoding && option.colorCoding.color ? '10px' : ''
                }"
              >
                <div v-if="componentData.colorCodeEnabled && id === option.id">
                  <AlertMessage :backgroundColor="option.colorCoding && option.colorCoding.color"
                                :message="option.colorCoding && option.colorCoding.warningMessage" />
                </div>
              </div>
            </div>
          </b-form-checkbox>

          <div v-if="otherOptionModel.isEnabled" class="light other-option-wrap">
            <b-form-checkbox :key="otherOptionModel.id" :value="otherOptionModel.id" class="light">
              {{ otherOptionModel.label }}
            </b-form-checkbox>

            <div v-if="otherOptionModel.hasComment && isOtherSelected"
                 :class="{ 'disabled-area': !isOtherSelected, 'active-area': isOtherSelected }"
                 class="other-option-comment">
                    <textarea v-model="otherOptionModel.value"
                              :disabled="!isOtherSelected"
                              :maxlength="otherOptionModel.commentMaxLength"
                              :placeholder="otherOptionModel.comment"
                              class="other-option-comment-area"
                              @keydown="preventInvalidCharacters"
                              @change="onOtherCommentChange">
                    </textarea>

              <div :class="{'max-character-limit': otherCommentLength >= otherOptionModel.commentMaxLength}"
                   class="other-option-comment-count">
                {{ otherCommentLength }} / {{ otherOptionModel.commentMaxLength }}
              </div>
            </div>
          </div>
        </b-form-checkbox-group>
      </b-form-group>
      <span v-if="hasFieldError" class="text-danger pl-5 fw-bold pt-10">{{ fieldErrorText }}</span>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";
import { Widget } from "@/components/services/participant-service";

export default {
  name: "multiple-choice",
  mixins: [langTranslate],
  data() {
    return {
      widget: new Widget(),
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {},
      otherOptionModel: {},
      updatedAnswersIds: []
    };
  },
  mounted() {
    this.$root.$on("questionSkipped", (notifyObj) => {
      if (!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped) {
        this.clearAnswer();
      }
    });
    this.updatedAnswersIds = this.question.optionsIds || [];
    this.insertOtherOption();
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    isOtherSelected() {
      return this.otherOptionModel.id ? this.updatedAnswersIds.includes(this.otherOptionModel.id) : false;
    },
    otherCommentLength() {
      return this.otherOptionModel.value ? this.otherOptionModel.value.length : 0;
    },
    filteredOptions() {
      return this.componentData && this.componentData.options ? this.componentData.options.filter(c => c.id !== this.otherOptionModel.id) : [];
    },
    componentData() {
      return this.question.constraints;
    },
    getImage() {
      return this.question && this.question.bodyImages && this.question.bodyImages[0].imageUrl;
    }
  },
  methods: {
    onOtherCommentChange(event) {
      const value = event.target.value;

      if (value && typeof value === "string") {
        event.preventDefault();
        this.otherOptionModel.value = value.replaceAll(":", "");
        this.$forceUpdate();
        this.onAnswerChange();
      }
    },
    preventInvalidCharacters(event) {
      if (event.key === ":") {
        event.preventDefault();
      }
    },
    updateQuestionIds(event) {
      this.question.optionsIds = event || this.updatedAnswersIds || [];
    },
    onAnswerChange(event) {
      this.updateQuestionIds(event);

      if (this.isOtherSelected) {
        this.question.otherAnswer = this.otherOptionModel.value;
      }

      this.$nextTick(() => {
        this.$emit("onAnswerChange", this.question);
      });
    },
    clearAnswer() {
      this.question.answer = undefined;
      this.updatedAnswersIds = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;

      this.$emit("getQuestionScores");
      this.$emit("onClearAnswer", this.question);
    },
    calculateScoresMap() {
      if (this.componentData.options) {
        this.componentData.options.forEach(option => {
          this.scoresMap[option.id] = option.score || 0;
        });
      }
    },
    insertOtherOption() {
      if (this.question && this.question.otherOptionId) {
        const sequence = this.componentData.options.length + 1;

        const option = {
          body: this.question.otherOptionContentField,
          colorCoding: {
            color: "#fff",
            warningMessage: null
          },
          enabled: this.question.isDisplayOtherOptionContentField === true,
          excludeScore: false,
          formattedBody: this.question.otherOptionContentField,
          id: this.question.otherOptionId,
          isAdvancedScoring: this.componentData.advancedScoring,
          priority: 0,
          sendNotification: false,
          sequence: sequence
        };

        this.otherOptionModel = {
          id: this.question.otherOptionId,
          isEnabled: this.question.isDisplayOtherOptionContentField === true,
          hasComment: this.question.isDisplayOtherCommentSelectedField === true,
          comment: this.question.otherCommentSelectedField,
          label: this.question.otherOptionContentField,
          commentMaxLength: 1000,
          value: this.question.otherAnswer || ""
        };

        this.componentData.options.push(option);
      }
    }
  }
};
</script>
<style scoped>
/deep/ .custom-control-label {
  white-space: normal !important;
  width: 100%;
}

.instruction_title p:first-child {
  font-weight: 600 !important;
}

.instruction_title {
  font-weight: normal;
}

.other-option-comment {
  width: 100%;
  margin-top: 15px;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 0 0 1px #4a4a4a;
  padding-bottom: 20px;
}

.disabled-area {
  background-color: rgb(245, 245, 245);
}

.active-area {
  box-shadow: 0 0 0 2px #007bff;
}

.other-option-comment-area {
  resize: none;
  width: 100%;
  padding: 10px;
  border: 0;
}

.other-option-comment-count {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: small;
}

.max-character-limit {
  color: crimson;
}

.other-option-wrap {
  flex-direction: column;
  align-items: start;
}
</style>
